module.exports = __webpack_public_path__ + "static/media/loginBg.1e5998dd.jpg";